import App from './App'
import 'bootstrap/dist/css/bootstrap.css'
import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import Cookies from 'js-cookie'
import {
   createBrowserRouter,
   RouterProvider,
   useRouteError,
} from 'react-router-dom'
import { QueryProvider } from './context/QueryProvider'
import { AuthContextProvider } from './context/AuthContext'

import * as Quote from './quote/Quote'
import sad_panda from './images/sad_panda.png'

///////////////////////////
// Console Output Capturing
///////////////////////////
// This array will hold all console outputs
let consoleOutput = []

const referrer = document.referrer
const internally_accessed =
   referrer.includes('force.com') || referrer.includes('quote.bamboohr.net')
      ? true
      : false

// Store the original console functions
let oldConsole = {
   log: console.log,
   error: console.error,
   warn: console.warn,
}

// Function to intercept console calls
function intercept(method, args) {
   consoleOutput.push({ method: method, arguments: Array.from(args) })
   oldConsole[method].apply(console, args)
}

// Override the console methods
console.log = function () {
   intercept('log', arguments)
}

console.error = function () {
   intercept('error', arguments)
}

console.warn = function () {
   intercept('warn', arguments)
}

// Capture unhandled errors
window.addEventListener('error', function (event) {
   consoleOutput.push({
      method: 'error',
      arguments: [event.message, event.filename + ':' + event.lineno],
   })
})

// React component to download the console output
const ConsoleDownloadButton = () => {
   const downloadConsoleOutput = () => {
      // Create the content of the log file
      // Add accessed url and referrer to log file
      let content = 'accessed url:' + window.location.href + '\n\n'
      content += 'referrer:' + referrer + '\n\n'
      // If accessed internally, add console output to log file, else, log just the first caught error message.
      if (internally_accessed)
         content += consoleOutput
            .map((entry) => {
               return `[${entry.method}] ${entry.arguments.join(' ')}`
            })
            .join('\n')
      else
         content += `[${consoleOutput[0].method}] ${consoleOutput[0].arguments.join(' ')}`

      let blob = new Blob([content], { type: 'text/plain' })
      let url = URL.createObjectURL(blob)

      let a = document.createElement('a')
      a.href = url
      a.download = 'quote_app_errors.log'
      a.click()

      URL.revokeObjectURL(url)
   }

   return (
      <button className='error-log-button' onClick={downloadConsoleOutput}>
         Download Browser Error
      </button>
   )
}
///////////////////////////^^^
// Console Output Capturing ^^
///////////////////////////^^^

// Takes token supplied in url called 'access_token' and stores as cookie.
function setAccessTokenCookie() {
   let search = window.location.search
   let params = new URLSearchParams(search)
   let paramObj = {}
   for (var value of params.keys()) {
      paramObj[value] = params.get(value)
   }

   let cookieAttributes = {
      sameSite: 'None', // Limits cookie access to domain issuing.
      secure: true, // Allows http if in development only
      expires: 0.5, //expires after 12 hours
   }

   if (paramObj.hasOwnProperty('access_token')) {
      Cookies.set('access_token', paramObj['access_token'], cookieAttributes)
   }
}

// Removes a paramter from a url
function removeParamFromURL(url, param) {
   const [path, searchParams] = url.split('?')

   const newSearchParams = searchParams
      ?.split('&')
      .filter((p) => !(p === param || p.startsWith(`${param}=`)))
      .join('&')

   return newSearchParams ? `${path}?${newSearchParams}` : path
}

// Function containing the error page
const Error = () => {
   const error = useRouteError()
   console.error(error)
   return (
      <>
         <div className='flex-container'>
            <div className='container-1'>
               <div className='content-1'>
                  <div>
                     <div className='fs-1'>Oops! Something went wrong.</div>
                     <p></p>
                     <p className='fs-5'>
                        {internally_accessed
                           ? "Try refreshing your page. If the error persists, please click 'Download Browser Error' button and attach the file to a new support ticket at datadesk.bamboohr.net"
                           : "Try refreshing your page. If the error persists, please click the 'Download Browser Error' button and send the file to your BambooHR Partner Rep."}
                     </p>
                  </div>
                  <img
                     src={sad_panda}
                     style={{ width: '300px' }}
                     alt='Sad Panda'
                  ></img>
               </div>
               <ConsoleDownloadButton />
            </div>
         </div>
      </>
   )
}

// React router routes defintion
const router = createBrowserRouter([
   {
      path: '/',
      element: <App />,
      errorElement: <Error />,
   },
   {
      path: '/quote',
      element: <Quote.QuotePreview />,
      errorElement: <Error />,
   },
   {
      path: '/pdf',
      element: <Quote.PDF />,
      errorElement: <Error />,
   },
])

// Sets access token as a cookie
setAccessTokenCookie()
// Removes access token from url.
window.history.replaceState(
   {},
   document.title,
   removeParamFromURL(window.location.href, 'access_token'),
)

const rootElement = document.getElementById('root')
if (rootElement) {
   ReactDOM.createRoot(rootElement).render(
      //<React.StrictMode>
      <QueryProvider>
         <AuthContextProvider>
            <RouterProvider router={router} />
         </AuthContextProvider>
      </QueryProvider>,
      //</React.StrictMode>
   )
} else {
   console.error('Root element not found')
}
